import React from 'react';
import * as S from './styles';
import { ButtonProps } from './types';

function ForwardedButton<
  T extends Element = HTMLButtonElement,
  As extends React.ElementType = 'button',
>(
  {
    as,
    children,
    fluid = false,
    color = 'primary',
    size = 'large',
    variant = 'solid',
    startIcon: startIconProp,
    endIcon: endIconProp,
    ...props
  }: ButtonProps<As>,
  ref: React.ForwardedRef<T>,
) {
  const Component: React.ElementType = as ?? 'button';
  const startIcon = startIconProp && (
    <S.ButtonStartIcon>{startIconProp}</S.ButtonStartIcon>
  );

  const endIcon = endIconProp && (
    <S.ButtonEndIcon>{endIconProp}</S.ButtonEndIcon>
  );
  return (
    <S.Button
      {...props}
      $color={color}
      $fluid={fluid}
      $size={size}
      $variant={variant}
      ref={ref}
      forwardedAs={Component}
    >
      {startIcon}
      {children}
      {endIcon}
    </S.Button>
  );
}

/**
 * Basic accessible button component.
 */
export const Button = React.forwardRef(ForwardedButton) as <
  T extends Element = HTMLButtonElement,
  As extends React.ElementType = 'button',
>(
  props: ButtonProps<As> & { ref?: React.Ref<T> },
) => React.ReactElement | null;

export default Button;
